import type { ReactNode } from "react";
import { SeverityPill, type SeverityPillColor } from "../generic/components/severity-pill";
import type { MomentStatus } from "./types";

export const statusToPill = (
  status: MomentStatus,
  valueMap: { [_: string]: SeverityPillColor } = {
    draft: "warning",
    paused: "disabled",
    active: "error",
    finished: "info",
    archived: "disabled",
  },
): ReactNode => {
  return (
    <SeverityPill color={valueMap[status]!} data-testid={status + "-pill"}>
      {status}
    </SeverityPill>
  );
};
